


































































































import PaperPlanIcon from '@/app/ui/assets/paper_plane_icon.vue'
import ListIcon from '@/app/ui/assets/list_icon.vue'
import dayjs from 'dayjs'
import { Component, Prop, Vue } from 'vue-property-decorator'
import dayjsDuration from 'dayjs/plugin/duration'
import { Utils } from '@/app/infrastructures/misc'
import { CourierPickupDetail, Pickup } from '@/domain/entities/Pickup'
import EyeIcon from '@/app/ui/assets/eye.vue'
import EyeDisabledIcon from '@/app/ui/assets/eye_disabled.vue'
import PickupController from '@/app/ui/controllers/PickupController'

dayjs.extend(dayjsDuration)

@Component({
  components: {
    PaperPlanIcon,
    ListIcon,
    EyeIcon,
    EyeDisabledIcon
  },
})
class PickupItemDOX extends Vue {
  @Prop({ required: true }) public no!: number
  @Prop({ required: true }) public data!: Pickup

  get date(): string {
    return Utils.formatDateWithIDLocale(
      this.data.createdAt,
      'DD-MMM-YYYY',
    )
  }

  get time(): string {
    return Utils.formatTimeZone(
      Utils.formatDateWithIDLocale(
        this.data.createdAt,
        'HH:mm Z'
      ),
    )
  }

  get duration(): string {
    const duration = dayjs.duration(dayjs().diff(dayjs(this.data.createdAt)))

    const result = []

    //Get Days
    const days = Math.floor(duration.asDays())
    if (days) {
      result.push(`${days}d`)
    }

    //Get Hours
    const hours = duration.hours()
    if (hours) {
      result.push(`${hours}h`)
    }

    //Get Minutes
    const minutes = duration.minutes()
    result.push(`${minutes}m`)

    return result.join(', ')
  }

  get overSLA(): boolean {
    return dayjs().diff(dayjs(this.data.createdAt), 'hours') >= 48
  }

  get isBosspack(): boolean {
    return this.data.productType === 'BOSSPACK'
  }

  get courierPickupDetail(): CourierPickupDetail {
    return <CourierPickupDetail>this.data.courierPickupDetail
  }

  async showCustPhone(event: any) {
    event.stopPropagation();

    const resp = await PickupController.adminContactShow({
      field: 'pickup_phone',
      resource: 'shipment',
      resourceId: this.data.shipmentId,
      source: 'pickup_dox'
    })

    this.data.pickup!.phoneNumber = resp.value;
  }

  hideCustPhone(event: any) {
    event.stopPropagation();
    this.data.pickup!.phoneNumber = '';
  }

  async showCourierPhone(event: any) {
    event.stopPropagation();

    const resp = await PickupController.adminContactShow({
      field: 'courier_phone',
      resource: 'courier',
      resourceId: String(this.data.courierPickupDetail!.courierId),
      source: 'pickup_dox'
    })

    this.data.courierPickupDetail!.phoneNumber = resp.value;
  }

  hideCourierPhone(event: any) {
    event.stopPropagation();
    this.data.courierPickupDetail!.phoneNumber = '';
  }

  async showCustAddress(event: any) {
    event.stopPropagation();

    const resp = await PickupController.adminContactShow({
      field: 'pickup_address',
      resource: 'shipment',
      resourceId: String(this.data.shipmentId),
      source: 'pickup_dox'
    })

    this.data.pickup!.address = resp.value;
  }

  hideCustAddress(event: any) {
    event.stopPropagation();

    this.data.pickup!.address = '';
  }
}

export default PickupItemDOX
